export function CreatedBy() {
  return (
    <a
      href="https://blog.bonneto.ca"
      className="relative inset-x-0 bottom-0 text-gray-300 m-4 flex justify-center"
    >{`Developped by Olivier Bonnet, ${new Date().getFullYear()}`}</a>
  );
}
